import React from 'react';

import { useState, useEffect, useContext } from 'react';

import { Button, Table, OverlayTrigger, Tooltip } from 'react-bootstrap';

import useRequest from '../helper/useRequest';
import { toast } from 'react-toastify';
import AppContext from '../AppContext';
import useConfirmation from '../helper/Confirmation';
import Loader from '../helper/Loader';

import TableHeader from '../helper/TableHeader';

import {
    createColumnHelper,
    flexRender,
    getCoreRowModel,
    getSortedRowModel,
    getFilteredRowModel,
    useReactTable,
} from '@tanstack/react-table';

const columnHelper = createColumnHelper();

import AddContactperson from '../helper/Contactperson/AddContactpersonModal';
import EditContactperson from '../helper/Contactperson/EditContactpersonModal';

function Contactperson() {
    const { getSalutation } = useContext(AppContext);
    const { request } = useRequest();
    const confirmation = useConfirmation();

    const [realPersons, setRealPersons] = useState(false);
    const [persons, setPersons] = useState(false);
    const [modal, setModal] = useState(false);
    const [editModal, setEditModal] = useState(false);
    const [person, setPerson] = useState(false);
    const [user, setUser] = useState({});
    const [contactLabel, setContactLabel] = useState("Kontaktperson");
    const [userTypeLabel, setUserTypeLabel] = useState("School");

    const [addMessage, setAddMessage] = useState("");
    const [editMessage, setEditMessage] = useState("");

    const [sorting, setSorting] = useState([]);
    const [columnFilters, setColumnFilters] = useState([]);

    const loadData = async () => {
        try {
            let result = await request("/User/GetContactpersons");
            let json = result.data;
            if (json.r != 1) {
                if (json.message) {
                    toast.info(json.message);
                }
                else {
                    toast.error("Es ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.");
                }
            }
            else {
                setRealPersons(json.persons);
            }
        }
        catch {
            toast.error("Laden der " + contactLabel + " fehlgeschlagen.");
        }
    };

    const addPerson = async (values) => {
        try {
            setAddMessage("");
            const result = await request("/User/AddContactperson", {
                SalutationID: values.salutation,
                Title: values.title,
                FirstName: values.firstname,
                LastName: values.lastname,
                Email: values.email,
                PhoneNo: values.phone,
                DefaultPerson: values.default,
                ReminderOptIn: values.optIn,
                CriminalRecord: values.criminalRecordFile != null ? '1' : '0',
                criminalRecordFile: values.criminalRecordFile
            });
            const json = result.data;

            if (json.r == 1) {
                var text = contactLabel + " erfolgreich hinzugefügt.";
                toast.success(text);
                updatePersons(json.person);
                setModal(false);
            }
            else {
                setAddMessage(json.message);
            }
        }
        catch (ex) {
            console.error(ex);
            setAddMessage("Es ist ein Fehler aufgetreten.");
        }
    }

    const editPerson = async (values) => {
        try {
            setEditMessage("");
            const result = await request("/User/UpdateContactperson", {
                SalutationID: values.salutation,
                Title: values.title,
                FirstName: values.firstname,
                LastName: values.lastname,
                Email: values.email,
                PhoneNo: values.phone,
                DefaultPerson: values.default,
                ReminderOptIn: values.optIn,
                ContactPersonID: person.ContactPersonID,
                CriminalRecord: values.criminalRecordFile != null ? person.CriminalRecord : '1',
                criminalRecordFile: values.criminalRecordFile
            });
            const json = result.data;

            if (json.r == 1) {
                var text = contactLabel + " erfolgreich gespeichert.";
                toast.success(text);
                updatePersons(json.person);
                setEditModal(false);
                setPerson(false);
            }
            else {
                setEditMessage(json.message);
            }
        }
        catch (ex) {
            console.error(ex);
            setEditMessage("Es ist ein Fehler aufgetreten.");
        }
    }

    const getUser = async () => {
        try {
            let result = await request("/User");
            let json = result.data;
            if (json.r != 1) {
                if (json.message) {
                    toast.error(json.message);
                }
                else {
                    toast.error("Es ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.");
                }
            }
            else {
                setUser(json.user);
            }
        }
        catch {
            toast.error("Fehler beim Laden.");
        }
    };

    const updatePersons = (person) => {
        setRealPersons((items) => {
            if (person.DefaultPerson) {
                for (var i = 0; i < items.length; i++) {
                    items[i].DefaultPerson = false;
                }
            }

            var i = items.findIndex(item => item.ContactPersonID == person.ContactPersonID);
            if (i > -1) {
                items[i] = person;
            } else {
                items.push(person);
            }

            return [...items];
        });
    }

    const selectPerson = (person) => {
        setPerson(realPersons.find(m => m.ContactPersonID == person.ContactPersonID));
        setEditModal(true);
    };

    const confirmDeletePerson = (person) => {
        if (person.DefaultPerson) {
            var text = (contactLabel !== "Kontaktperson" ? "Der" : "Die") + " Standard-"+ contactLabel +" kann nicht gelöscht werden. Ändern Sie " + (contactLabel !== "Kontaktperson" ? "den" : "die") + " Standard-"+contactLabel+" und versuchen Sie die Löschung erneut. Handelt es sich um " + (contactLabel !== "Kontaktperson" ? "den einzigen " : "die einzige ") + contactLabel +" müssen Sie sich zwecks Löschung an den Betreiber des Webportals wenden."
            return toast.error(text);
        }
        var heading =  contactLabel +" löschen?";
        var text = "Soll " + (contactLabel !== "Kontaktperson" ? "der " : "die ") + contactLabel + " " + person.FirstName + " " + person.LastName + " wirklich unwiderruflich gelöscht werden?";
        confirmation.openModal(heading, text, () => { deletePerson(person) }, "Ja", "Nein")
    };

    const deletePerson = async (person) => {
        try {
            const result = await request("/User/DeleteContactperson", {
                ContactPersonID: person.ContactPersonID
            });
            const json = result.data;

            if (json.r == 1) {
                var text = contactLabel + " erfolgreich gelöscht." ;
                toast.success(text);
                setPersons(items => items.filter(i => i.ContactPersonID != person.ContactPersonID));
            }
            else {
                toast.error(json.message);
            }
        }
        catch (ex) {
            console.error(ex);
            toast.error("Es ist ein Fehler aufgetreten.");
        }
    };
    const checkRole = (role) => {
        if (role == "School") {
            setContactLabel("Kontaktperson");
            setUserTypeLabel("School");
        }
        else if (role == "Business") {
            setContactLabel("Referent");
            setUserTypeLabel("Business");
        }
    }
    useEffect(() => {
        checkRole(user.Role);
    }, [user]);

    useEffect(() => {
        getUser();
        loadData();
    }, []);

    useEffect(() => {
        if (!realPersons) return setPersons(realPersons);

        setPersons(realPersons.map(m => {
            return { ...m, SalutationID: getSalutation(m.SalutationID) };
        }));
    }, [realPersons]);

    const columns = [
        columnHelper.accessor('SalutationID', {
            header: () => <span>Anrede</span>,
            cell: info => info.getValue(),
            enableColumnFilter: true,
        }),
        columnHelper.accessor('Title', {
            header: () => <span>Titel</span>,
            cell: info => info.getValue(),
            enableColumnFilter: true,
        }),
        columnHelper.accessor('FirstName', {
            header: () => <span>Vorname</span>,
            cell: info => info.getValue(),
            enableColumnFilter: true,
        }),
        columnHelper.accessor('LastName', {
            header: () => <span>Nachname</span>,
            cell: info => info.getValue(),
            enableColumnFilter: true,
        }),
        columnHelper.accessor('Email', {
            header: () => <span>E-Mail</span>,
            cell: info => info.getValue(),
            enableColumnFilter: true,
        }),
        columnHelper.accessor('PhoneNo', {
            header: () => <span>Telefon</span>,
            cell: info => info.getValue(),
            enableColumnFilter: true,
        }),
        columnHelper.accessor('DefaultPerson', {
            header: () => <span>Standard-{contactLabel}</span>,
            cell: info => <div className="text-center">{info.getValue() && <i className="fas fa-lg fa-check"></i>}</div>,
            enableColumnFilter: false,
        }),
        //columnHelper.accessor('CriminalRecord', {
        //    header: () => <span>erweitertes Führungszeugnis</span>,
        //    cell: info => info.getValue() == 0 ? 'Kein Führungszeugnis' : info.getValue() == 1 ? 'Nicht verifiziertes Führungszeugnis' : 'Verifiziertes Führungszeugnis',
        //    enableColumnFilter: false,
        //}),
        columnHelper.accessor('ContactPersonID', {
            header: () => <span></span>,
            cell: info => {
                return <div className="text-end" >
                    <OverlayTrigger overlay={<Tooltip>Bearbeiten</Tooltip>}>
                        <Button className="mr-1" variant="primary" size="sm" onClick={() => selectPerson(info.row.original)}><i className="fa-solid fa-fw fa-pen"></i></Button>
                    </OverlayTrigger>
                    <OverlayTrigger overlay={<Tooltip>Löschen</Tooltip>}>
                        <Button variant="danger" size="sm" onClick={() => confirmDeletePerson(info.row.original)}><i className="fa-solid fa-fw fa-trash"></i></Button>
                    </OverlayTrigger>
                </div>;
            },
            enableSorting: false,
            enableColumnFilter: false,
            size: 140
        }),
    ]

    const reactTable = useReactTable({
        data: persons || [],
        columns,
        state: {
            sorting,
            columnFilters,
        },
        onSortingChange: setSorting,
        onColumnFiltersChange: setColumnFilters,

        getCoreRowModel: getCoreRowModel(),
        getSortedRowModel: getSortedRowModel(),
        getFilteredRowModel: getFilteredRowModel(),
    });


    if (!persons) return <Loader />

    return (
        <>
            <h1>{contactLabel}en verwalten</h1>
            <p>Auf dieser Seite können Sie neue {contactLabel}en für Ihre Organisation eintragen. Diese {contactLabel}en dienen nur der Hinterlegung der Personen in Terminen und sie erhalten kein eigenes Login für das Webportal.<br /></p>
            <Button type="button" className="mb-2" id="addContactperson" variant="primary" onClick={() => setModal(true)}>{contactLabel} hinzufügen</Button>
            <Table striped responsive="xl">
                <thead>
                    {reactTable.getHeaderGroups().map(headerGroup => (
                        <TableHeader key={headerGroup.id} table={reactTable} headerGroup={headerGroup} flexRender={flexRender} />
                    ))}
                </thead>
                <tbody>
                    {reactTable.getRowModel().rows.map(row => (
                        <tr key={row.id}>
                            {row.getVisibleCells().map(cell => {
                                return (
                                    <td key={cell.id}>
                                        {flexRender(cell.column.columnDef.cell, cell.getContext())}
                                    </td>
                                )
                            })}
                        </tr>
                    ))}
                </tbody>
            </Table>
            {userTypeLabel == "School" 
                ? <AddContactperson modal={modal} setModal={setModal} addPerson={addPerson} contactLabel={contactLabel} message={addMessage} userType={"School"} /> 
                : <AddContactperson modal={modal} setModal={setModal} addPerson={addPerson} contactLabel={contactLabel} message={addMessage} userType={"Business"} /> 
            }
            {userTypeLabel == "School"
                ? <EditContactperson modal={editModal} setModal={setEditModal} person={person} setPerson={setPerson} editPerson={editPerson} contactLabel={contactLabel} message={editMessage} userType={"School"} />
                : <EditContactperson modal={editModal} setModal={setEditModal} person={person} setPerson={setPerson} editPerson={editPerson} contactLabel={contactLabel} message={editMessage} userType={"Business"} />
            }
        </>
    );
}

export default Contactperson;